import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15.612 7.999 8.875 15 2.137 7.999a4.147 4.147 0 1 1 6.738-4.667 4.146 4.146 0 1 1 6.737 4.667" }, null, -1)
  ]))]))
}
export default { render: render }